import { useNavigate, useLocation } from "react-router-dom";

import FooterButton from "../footer/footerButton";

import { checkPartner } from "../../api/gamePartner.js";

import "./wait.css";

export default function Wait() {
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state || {};
  const { DateVal, userRole, introInCodeV } = state;

  const handleButtonClick = async () => {
    const checkPartnerSolved = await checkPartner(
      DateVal,
      userRole,
      introInCodeV,
    );

    if (!checkPartnerSolved) {
      // 파트너 퀴즈 풀이 대기
      alert("파트너가 정답을 입력할 때까지 대기하세요.");
    } else {
      navigate("/keywordInput");
    }
  };

  return (
    <div id="content" className="waitDiv">
      <div className="boxPop content_box1">
        <div className="box_con  con_box_wait con_pd9 ">
          <div className="missionDiv">
            <div className="missionDi">
              <div className="mission_tit mission_tit_a3 mt40 "></div>
              <div className="mission_txt_b mt16 hint_text ">
                파트너가 정답을 입력할 때까지 <br />
                대기하세요.
              </div>
            </div>
          </div>

          {/* <input
            type="button"
            className="inputBtn02 btnCode go_url_btn"
            value={buttonData.label}
            onClick={handleButtonClick}
          /> */}

          <FooterButton
            ftIdName="box_ft"
            buttonClass="inputBtn02 con_box_wait_btn"
            buttonValue="대기 종료"
            onFinish={handleButtonClick}
          />
        </div>
      </div>
    </div>
  );
}
